import React, { useEffect, useRef } from "react";
import useWindowSize from "../../utils/ScreenSize";


// CSS Modules styles
const styles = {
  container: {
    position: "relative",
    textAlign: "center",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(27, 49, 94, 1)",
  },
  overlay: {
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(27, 49, 94, 0.28)",
    zIndex: "1",
    pointerEvents: "none",
  },
  particles: {
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    zIndex: "0",
  },
  title: {
    fontSize: "40px",
    maxWidth: "860px",
    fontWeight: "700",
    color: "rgba(255, 255, 255, 1)",
    margin: "0",
    position: "relative",
    zIndex: "2",
  },
  subtitle: {
    fontSize: "18px",
    color: "rgba(255, 255, 255, 0.85)",
    paddingTop: "20px",
    position: "relative",
    zIndex: "2",
  },
};

const Header = ({ headerTitle, subTitle }) => {
  const { width } = useWindowSize();
  const isSmallScreen = width < 768;
  const particlesIdRef = useRef(
    `header-particles-${Math.random().toString(36).slice(2, 10)}`
  );

  useEffect(() => {
    const initParticles = () => {
      if (!window.particlesJS) return;

      window.particlesJS(particlesIdRef.current, {
        particles: {
          number: {
            value: isSmallScreen ? 45 : 85,
            density: { enable: true, value_area: 900 },
          },
          color: { value: ["#ffffff", "#8ed0ff", "#4aa3ff"] },
          shape: { type: ["circle", "triangle", "triangle"] },
          opacity: {
            value: 0.75,
            random: true,
            anim: { enable: true, speed: 0.2, opacity_min: 0.2, sync: false },
          },
          size: {
            value: 2.5,
            random: true,
            anim: { enable: false, speed: 8, size_min: 0.4, sync: false },
          },
          line_linked: {
            enable: true,
            distance: 140,
            color: "#c2e7ff",
            opacity: 0.55,
            width: 1,
          },
          move: {
            enable: true,
            speed: 1.4,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: false, mode: "grab" },
            onclick: { enable: false, mode: "push" },
            resize: true,
          },
        },
        retina_detect: true,
      });
    };

    let injectedScript = null;
    if (!window.particlesJS) {
      injectedScript = document.createElement("script");
      injectedScript.src =
        "https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js";
      injectedScript.async = true;
      injectedScript.onload = initParticles;
      document.body.appendChild(injectedScript);
    } else {
      initParticles();
    }

    return () => {
      if (window.pJSDom && window.pJSDom.length) {
        window.pJSDom.forEach((instance) => {
          const parentId = instance?.pJS?.canvas?.el?.parentNode?.id;
          if (parentId === particlesIdRef.current) {
            instance.pJS.fn.vendors.destroypJS();
          }
        });
        window.pJSDom = (window.pJSDom || []).filter(
          (instance) =>
            instance?.pJS?.canvas?.el?.parentNode?.id !== particlesIdRef.current
        );
      }

      if (injectedScript && document.body.contains(injectedScript)) {
        document.body.removeChild(injectedScript);
      }
    };
  }, [isSmallScreen]);

  const words = (headerTitle || "").trim().split(/\s+/).filter(Boolean);
  const lastWord = words.length ? words[words.length - 1] : "";
  const beforeLast = words.slice(0, -1).join(" ");

  return (
    <section
      style={{
        ...styles.container,
        minHeight: "160px",
        marginTop: isSmallScreen ? -60 : -70,
        paddingTop: isSmallScreen ? 60 : 70,
      }}
    >
      <div id={particlesIdRef.current} style={styles.particles}></div>
      <div style={styles.overlay}></div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: isSmallScreen ? 24 : 52,
          width: "100%",
          alignItems: "center",
        }}
      >
        <h2
          style={{
            ...styles.title,
            fontSize: isSmallScreen ? "36px" : "48px",
            textAlign: "center",
          }}
        >
          {beforeLast ? `${beforeLast} ` : ""}
          <span style={{ color: "rgba(255, 28, 92, 1)" }}>{lastWord}</span>
        </h2>
        {subTitle && (
          <p
            style={{
              ...styles.subtitle,
              paddingTop: isSmallScreen ? 12 : 16,
            }}
          >
            {subTitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default Header;
